import React, { useEffect, useState } from 'react'
import { BackButton, CancelButton, SubmitButton } from '../../../../Components/Utils/Buttons';
import { NuDataTime, NuDate, NuInput, NuTextArea } from '../../../../Components/Utils/Input';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import { useFormik } from 'formik';
import { useLocation, useNavigate } from 'react-router-dom';
import useAddFormData from '../../../../Components/Hooks/useAddFormData';
import * as yup from 'yup';
import MultiSelect from '../../../../Components/Utils/MultiSelect';
import { useToast } from '../../../../Components/Others/ToastServices';
import Attachement from '../../../../Components/Utils/CustomAttrachmentupload';
import DropDownAddMetaData from '../../../../Components/Utils/selectAddMetaData';
import useFetchMataData from '../../../../Components/Hooks/useFetchMataData';
import UseDropDown from '../../../../Components/Hooks/useDropDown';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
import { format, addMonths } from 'date-fns';
import axiosInstance from '../../../../Services/axiosCommon';
import { SettingHeading } from '../../../../Components/Utils/Settingheading';


function CreateSchedule() {
  const navigate = useNavigate();
  const location = useLocation();
  const { id, ref } = location.state || {};
  const {  addFormData ,isLoading} = useAddFormData();
  const { value: inspectionType,getData:refinspectionType } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Inspection_Type_Schedule"
  );  
   const { value: scheduleType,getData:refscheduleType } = useFetchMataData(
        `/dropdown/dropdown-details/`,
        "Schedule_Type_Schedule"
      ); 
        const { data: contract } = UseDropDown(`/contract/drop-down`);
  const now = new Date();
     const [createNew, setCreateNew] = useState({
    
     

      contractId:null,
      duration:"",
    startDate:"",
    endDate:"",
    // scheduleType:"",
    inspectionType:"",
    schedules:[],
    
  });

   const [selectedFile, setSelectedFile] = useState(null);
        const [image, setImage] = useState([]);
        const toast = useToast();
      
        function handleImageChange(e) {
          const maxFileSize = 200000000; // 200 MB
          const files = Array.from(e.target.files);
          let fileArr = [];
          files.map((item) => {
            if (item.size < maxFileSize) {
              fileArr.push(item);
            } else {
              toast.open({
                type: "warning",
                message: `File Size to big`,
                description: `${item.name} is Removed and not Uploaded`,
                // placement: "bottomRight",
              });
            }
          });
          let tempArr = [];
          setSelectedFile(fileArr);
          files.map((item) => {
            if (item.size < maxFileSize) {
              let fileName = item?.name;
              console.log("fname", fileName);
              // let fileExtention = fileName.split(".").reverse()[0];
              // if (filetype?.includes(fileExtention)) {
              tempArr.push(fileName);
              // } else {
              //   let x = URL.createObjectURL(item);
              //   tempArr.push(x);
              // }
            }
          });
          console.log(tempArr, "temp");
          setImage(tempArr);
        }
      
        const removeImages = (value) => {
          console.log("value", value);
          let List = selectedFile.filter((item) => item?.name !== value);
          console.log("LIst", List);
          setSelectedFile([...List]);
          let tempArr = [];
          List.map((item) => {
            let fileName = item?.name;
            // console.log('fname',fileName);
            // let fileExtention =  fileName.split(".").reverse()[0]
            // if(filetype?.includes(fileExtention)){
            tempArr.push(fileName);
            // }else{
            //   let x = URL.createObjectURL(item)
            //   tempArr.push(x)
            // }
          });
          setImage(tempArr);
        };
  
      const [rows, setRows] = useState([]);

        const validationSchema = yup.object({
              duration: yup.string().required("Duration is required!"),
              // clientId: yup.string().required("Client is required!"),
              
              startDate: yup.date().required('Start date is required'),
              endDate: yup
                .date()
                .required('End date is required')
                .min(yup.ref('startDate'), 'End date must be after start date'),
            
             
            });
const [useContract,setUseContract]=useState([])
      

  const formik = useFormik({
    inspectionType: '',
    schedules:rows || "",
    duration: '',
    // startDates: {
    //   1: '',
    //   2: '',
    //   3: '', // One entry per row ID
    // },
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema,
     context: {
      startDate: createNew.startDate,
      endDate: createNew.endDate,
    },
    // validationSchema: yup.object({
    //         contractId: yup.string().required("Contract is required!"),
      
    //       }),
    onSubmit: async (value, { resetForm }) => {
      let formData = new FormData();
      const valueWithItems = {
        ...value,
        schedules:useContract,

      };
      formData.append("json_data", JSON.stringify(valueWithItems));
   if (selectedFile !== null) {
        selectedFile.forEach((file) => {
          formData.append("attachments", file);
        });
      } else {
        formData.append("attachments", []);
      }
            await addFormData({url:`/schedules/new-schedule`, formData:formData,navigateUrl:`/inspection/schedule`,resetForm:resetForm   });

          //  addFormData("/schedules/new-schedule", formData, resetForm);
    },
  });
 
   const [startDate, setStartDate] = useState(format(now,"yyyy-MM-dd"));
    const [time, setTime] = useState(format(now , "HH:mm"));
    const inspectionMap = {
      Monthly: 1,
      Quarterly: 3,
      HalfYearly: 6,
      Yearly: 12
    };
    
    const calculateInspectionRows = (inspectionType, duration) => {
      const interval = inspectionMap[inspectionType];
      const totalMonths = parseInt(duration);
  
      if (!interval || !totalMonths) return [];
  
      return Array.from({ length: Math.floor(totalMonths / interval) }, (_, i) => {
        const date = addMonths(new Date(startDate + 'T' + time), (i + 1) * interval - interval);
        return {
          id: i + 1,
          date: format(date, 'yyyy-MM-dd'),
          time: format(date, 'HH:mm'),
          description:"",
          location:"",
        };
      });
    };
  
    useEffect(() => {
      const { inspectionType, duration } = formik.values;
      const updatedRows = calculateInspectionRows(inspectionType, duration);
      setRows(updatedRows);
      formik.setFieldValue('schedules', updatedRows);
    }, [formik.values.inspectionType, formik.values.duration, startDate, time]);
 
  const getCustomerRef = (id) => {
    if (id !== "") {
      axiosInstance
        .get(`/contract/${id}`)
        .then((res) => {
          let data = res.data.data;
         setUseContract(res.data.data.inspection)
    formik?.setFieldValue("duration", data.duration);
          // formik?.setFieldValue("inspectionType", data.inspectionType);
          
          formik?.setFieldValue("startDate", data.startDate);
          formik?.setFieldValue("endDate", data.endDate);

        })
        .catch((err) => {
          console.log(err, "err");
        });
    }
  };

  useEffect(() => {
   
    if (formik.values.contractId) {
      getCustomerRef(formik.values.contractId);
    }
  }, [formik.values.contractId]);
  return (
    <div className=" w-full h-full py-2 px-4 ">
         <div className="flex justify-between w-full ">      
          <Breadcrumb
                            items={[
                              // { name: "Client-Management" },
                              {
                                name: "Schedule",
                                link:"/inspection/schedule"
          
                               
                              },
                  
                              { name: "Create" },
                            ]}
                          /> 
         <BackButton />
       </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="w-full mx-auto h-[calc(100vh-145px)] bg-white rounded-xl overflow-hidden mt-4">
          <div className=" w-full h-full flex justify-start content-start flex-wrap py-2 px-4  overflow-y-auto">
            <div className="w-full">
            <SettingHeading title="Inspection Schedule "  />

            </div>
          {/* {!location.state && ( */}

            <FormikSelectTwo
              label="Contract "
              Options={contract}
              formik={formik}
              placeholder="Choose"
              name="contractId"
              isRequired={true}

              width="w-full md:w-1/2 lg:w-1/3"
            />
          {/* )} */}


<NuInput
              type="text"
              label="Duration"
              placeholder="Duration"
              formik={formik}
              name="duration"
              width="w-full md:w-1/2 lg:w-1/3"
              isRequired={true}
              disabled={true}
            />
             {/* <NuInput
              type="text"
              label="Inspection Type"
              placeholder="Inspection Type"
              formik={formik}
              name="inspectionType"
              width="w-full md:w-1/2 lg:w-1/3"
              isRequired={true}
              disabled={true}
            /> */}
             <NuDate
              label="Start Date"
              placeholder="Start Date"
              formik={formik}
              name="startDate"
              disabled={true}
             
              width="w-full md:w-1/3 md:-mt-2"
            />
            <NuDate
              label="End Date"
              placeholder="End Date"
              formik={formik}
              name="endDate"
              disabled={true}
             
              width="w-full md:w-1/3 md:-mt-2"
            />



             {/* {formik.values.duration && formik.values.inspectionType && (             
             <div className="overflow-x-auto flex  gap-4 p-7 w-full">
             <table className="w-full text-xs border  border-gray-300 ">
               <thead className="bg-gray-100 h-10">
                 <tr className=" w-full" >
                  <th className=" text-center ">S.No </th>
                  <th className=" text-center">Date </th>
                  <th className=" text-center">Description </th>
                  <th className=" text-center">Location </th>

                     
                 </tr>
               </thead>
             
               <tbody>
               {rows.map((schedules, index) => (
  <tr key={index}>
    <td className="px-4 py-2 text-center">{index + 1}</td>
    <td className="px-4 py-2 text-center">
      <NuDate
        formik={formik}
        name={`schedules.${index}.date`}
        width="w-full"
        min={formik.values.startDate}
        max={formik.values.endDate}
      />
    </td>
    <td className="px-4 py-2 text-center">
      <NuInput
        type="text"
        placeholder="Description"
        formik={formik}
        name={`schedules.${index}.description`}
        width="w-full"
      />
    </td>
    <td className="px-4 py-2 text-center">
      <NuInput
        type="text"
        placeholder="Location"
        formik={formik}
        name={`schedules.${index}.location`}
        width="w-full"
      />
    </td>
  </tr>
))}

               </tbody>
             </table>
             <div className="">
            
            </div>
            </div>
            )} */}
            
               {formik.values.contractId && (
  <div className="overflow-x-auto p-2 w-full my-4">
    {/* <h2 className="text-sm font-semibold text-[#111537] mb-4">Inspection Schedules</h2> */}

   {useContract?.length > 0 ? (
  <div className="border border-gray-300 rounded-lg shadow-sm overflow-hidden bg-white">
   

    <div className="overflow-x-auto">
      <table className="w-full text-xs border-collapse">
        <thead className="bg-baseColor-primary text-white h-10">
          <tr>
            <th className="px-4 py-2 text-left w-[5%]">S.No</th>
            <th className="px-4 py-2 text-left w-[20%]">Equipment</th>
            <th className="px-4 py-2 text-left w-[20%]">Location</th>
            <th className="px-4 py-2 text-left w-[10%]">Unit</th>
            <th className="px-4 py-2 text-left w-[10%]">Quantity</th>
            <th className="px-4 py-2 text-left w-[10%]">Type</th>
            <th className="px-4 py-2 text-left w-[25%]">Form</th>
          </tr>
        </thead>

        <tbody>
          {useContract?.map((schedules, index) => (
            <tr key={index} className="hover:bg-gray-50">
              <td className="px-4 py-2 text-left border">{index + 1}</td>
              <td className="px-4 py-2 text-left border">{schedules?.name}</td>
              <td className="px-4 py-2 text-left border">{schedules?.location}</td>
              <td className="px-4 py-2 text-left border">{schedules?.unit}</td>
              <td className="px-4 py-2 text-left border">{schedules?.quantity}</td>
              <td className="px-4 py-2 text-left border">{schedules?.inspectionType}</td>
              <td className="px-4 py-2 text-left border align-top">
                {schedules.formSelectionName?.length > 0 ? (
                  <div className="flex flex-col items-start space-y-1">
                    {schedules.formSelectionName.map((form, idx) => (
                      <span
                        key={idx}
                        className="text-xs font-medium text-gray-700"
                      >
                        {idx + 1}. {form}
                      </span>
                    ))}
                  </div>
                ) : (
                  <span className="text-gray-400 text-xs">-</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
) : (
  <p className="text-sm text-gray-500">No inspection schedules found for this contract.</p>
)}

  </div>
)}

            {/* <NuInput
              type="text"
              label="Location Map"
              placeholder="Location Map"
              formik={formik}
              name="locationMap"
              width="w-full md:w-1/2 lg:w-1/3"
               />
             <NuInput
              type="text"
              label="Google Coordinates"
              placeholder="Google Coordinates"
              formik={formik}
              name="googleCoordinates"
              width="w-full md:w-1/2 lg:w-1/3"
              /> */}
           
            {/* <div className="w-full">
                <p className="pb-2 pt-4 px-4 text-sm font-medium text-[#111537] underline decoration-textColor-main decoration-2 underline-offset-4">
                   Attachement :
                </p>
              </div>
              <Attachement
                handleChange={handleImageChange}
                preview={image || ""}
                width="w-full"
                label="Attach"
                multiple={true}
                removeImages={removeImages}
              /> */}
           
           <div className="w-full  my-4 mt-8 ">
              <div className=" flex justify-end gap-4">
                 <CancelButton
                  handleClick={() => {
                    navigate(-1);
                  }}
                />
                <SubmitButton isLoading={isLoading}/>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}


export default CreateSchedule
